import React from 'react';
import { useAuth } from './context/AuthContext';

export default function RequireInit({ children }) {
  const { initialized } = useAuth();
  if (!initialized) return <div style={{ textAlign: 'center', paddingTop: 100 }}>Loading...</div>;
  return children;
}
